import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {FORCED_CHECKIN_ROUTES} from './forced-checkin.routes';
import {ForcedCheckinComponent} from './forced-checkin.component';
import { ForcedCheckinMapComponent } from './forced-checkin-map/forced-checkin-map.component';
import {ForcedCheckinSearchService} from './shared/forced-checkin-search.service';
import {GeolocationService} from '../../shared/services/geolocation.service';
import { ForcedCheckinBucketComponent } from "./forced-checkin-bucket/forced-checkin-bucket.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";

@NgModule({
    imports: [
        RouterModule.forChild(FORCED_CHECKIN_ROUTES),
        SharedModule,
        InfiniteScrollModule
    ],
  declarations: [
    ForcedCheckinComponent,
    ForcedCheckinMapComponent,
    ForcedCheckinBucketComponent
  ],
  providers: [
    ForcedCheckinSearchService,
    GeolocationService
  ]
})
export class ForcedCheckinModule { }
